import { ref, computed, toValue } from 'vue';

export function useSortSpotsBy(spots, sortBy, defaultProperty = 'default') {
  const unsortedSpots = ref(spots);

  const sortedSpots = computed(() => {
    const sortOrder = toValue(sortBy);
    if (unsortedSpots.value.length === 0) return [];

    if (unsortedSpots.value.length === 0 || sortOrder === 'default' || sortOrder === defaultProperty) {
      return unsortedSpots.value;
    }

    return sortSpotsBy(unsortedSpots.value, sortOrder);
  });

  function sortSpotsBy(spots, sortBy) {
    const newSortedSpots = [...spots];

    if (sortBy === "windspeed") {
      return newSortedSpots.sort((a, b) => {
        const spotAValue = a.stations[0].data_values[0][a.data_names.indexOf('avg')];
        const spotBValue = b.stations[0].data_values[0][b.data_names.indexOf('avg')];

        return sortValue(spotAValue, spotBValue, 'descending');
      });
    }

    if (sortBy === "distance") {
      return newSortedSpots.sort((a, b) => {
        const spotAValue = a.distance;
        const spotBValue = b.distance;

        return sortValue(spotAValue, spotBValue);
      });
    }

    if (sortBy === "name") {
      return newSortedSpots.sort((a, b) => {
        const spotAValue = a.name;
        const spotBValue = b.name;

        return sortValue(spotAValue, spotBValue);
      });
    }

    if (sortBy === "provider") {
      return newSortedSpots.sort((a, b) => {
        const spotAValue = a.stations[0].provider;
        const spotBValue = b.stations[0].provider;

        return sortValue(spotAValue, spotBValue);
      });
    }

    return newSortedSpots;
  }
  
  function sortValue(a, b, order = 'ascending') {
    if (order === 'ascending') {
      if (a > b) return 1;
      if (a < b) return -1;
    }
  
    if (order === 'descending') {
      if (a > b) return -1;
      if (a < b) return 1;
    }
  
    return 0;
  }

  return sortedSpots;
}
